/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

import { Places } from '../../../interfaces';

export enum LocalTypes {
  LOCAIS_REQUEST = '@LOCAIS_REQUEST',
  LOCAL_REQUEST_BY_ID = '@LOCAL_REQUEST_BY_ID',
  LOCAIS_REQUEST_SUCCCES = '@LOCAIS_REQUEST_SUCCCES',
  LOCAIS_REQUEST_FAILURE = '@LOCAIS_REQUEST_FAILURE',
  CREATE_LOCAL = '@CREATE_LOCAL',
  UPDATE_LOCAL = '@UPDATE_LOCAL'
}

export interface LocaState {
  check?: boolean;
  idLocal: string;
  codigoCategoriaLocal: number;
  nomeCategoriaLocal: string;
  nome: string;
  endereco: string;
  numeroEndereco:string;
  complementoEndereco: string | null ;
  bairro: string;
  urlImagem: string;
  limiteAgendamentosTurnosPorUsuario: number;
  codigoClassificacao: number;
  nomeClassificacao: string;
  dobraPosicaoPermitida: boolean;
  localAtivo: boolean;
  usuarios: Array<{
    idUsuario: string,
    nome: string,
  }>
}

export interface LocaisStateReducer{
  readonly loadingLocalData: boolean;
  readonly localData: any
  readonly data: Array<Places>;
  readonly error: string;
  readonly isError: boolean;
  readonly loading: boolean;
  readonly clear: boolean;
  readonly saveSucess: boolean;
}

interface RequestLocal {
  PaginaAtual: number;
  TotalItensRetorno: number;
  CodigoCategoriaLocal?: number
}

export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_LOCAIS = 'SET_LOCAIS';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOCAL_DATA_BY_ID = 'SET_LOCAL_DATA_BY_ID';
export const SET_CLEAR_LOCAL_DATA_BY_ID = 'SET_CLEAR_LOCAL_DATA_BY_ID';
export const SET_LOADING_BY_ID = 'SET_LOADING_BY_ID';
export const SET_CREATED_LOCAL_SUCCESS = 'SET_CREATED_LOCAL_SUCCESS';

interface SetLocais{
  type: typeof SET_LOCAIS;
  payload: Array<LocaState>;
}

interface SetLocaLById{
  type: typeof SET_LOCAL_DATA_BY_ID;
  payload: any;
}

interface SetCleanLocaLById{
  type: typeof SET_CLEAR_LOCAL_DATA_BY_ID;
}

interface SetStateFromScreen{
  type: typeof SET_CREATED_LOCAL_SUCCESS;
  payload: boolean;
}

interface RequestLocais{
  type: typeof LocalTypes.LOCAIS_REQUEST;
}

interface RequestFailure{
  type: typeof LocalTypes.LOCAIS_REQUEST_FAILURE;
  payload: string
}

interface RequestCreateLocal{
  type: typeof LocalTypes.CREATE_LOCAL;
  payload: string
}

interface RequestUpdateLocal{
  type: typeof LocalTypes.UPDATE_LOCAL;
  payload: { payload: string, id: string}
}

interface RequestLocalByID {
  type: typeof LocalTypes.LOCAL_REQUEST_BY_ID;
  payload: string
}

interface SetLoading{
  type: typeof SET_LOADING;
  payload: Boolean;
}

interface SetSuccess{
  type: typeof SET_SUCCESS;
  payload: Boolean;
}

interface SetLoadingById{
  type: typeof SET_LOADING_BY_ID;
  payload: Boolean;
}

export type LocalActionType =
    | SetLocais
    | RequestLocais
    | RequestFailure
    | RequestCreateLocal
    | SetLoading
    | RequestLocalByID
    | SetLocaLById
    | SetLoadingById
    | SetCleanLocaLById
    | SetStateFromScreen
    | RequestUpdateLocal
    | SetSuccess
